// 認証関連ユーティリティ

/**
 * 現在のURLを含む東商マイページへのリダイレクトURLを生成
 */
export function getLoginRedirectUrl(): string {
  // 現在のパスを取得 (例: /, /company-info, /create-bcp など)
  const currentPath = window.location.pathname;

  // CloudFrontのベースURLを取得
  const baseUrl = window.location.origin;

  // /auth/start?redirect=<現在のパス> を構築
  // バックエンドはこのredirectパラメータを抽出して使用する
  const redirectUrl = `${baseUrl}/auth/start?redirect=${currentPath}`;
  const encodedUrl = encodeURIComponent(redirectUrl);

  // 環境変数から東商マイページURLを取得、デフォルトは検証環境
  const toshoMyPageUrl =
    import.meta.env.VITE_TOSHO_MYPAGE_URL ||
    'https://01.tokyocci-test.prod.powercms.cloud';

  return `${toshoMyPageUrl}/?logout=1&bcp_redirect_url=${encodedUrl}`;
}

/**
 * ログアウト後の東商マイページへのリダイレクトURLを生成
 */
export function getLogoutRedirectUrl(): string {
  // 環境変数から東商マイページURLを取得、デフォルトは検証環境
  const toshoMyPageUrl =
    import.meta.env.VITE_TOSHO_MYPAGE_URL ||
    'https://01.tokyocci-test.prod.powercms.cloud';

  return toshoMyPageUrl;
}

/**
 * 認証状態をチェック
 */
export async function checkAuthStatus(): Promise<boolean> {
  try {
    const response = await fetch('/auth/me', {
      credentials: 'include', // クッキーを含める
    });
    return response.ok;
  } catch (error) {
    console.error('認証チェックエラー:', error);
    return false;
  }
}

/**
 * 未認証の場合、東商マイページへリダイレクト
 */
export async function requireAuth(): Promise<void> {
  const isAuthenticated = await checkAuthStatus();

  if (!isAuthenticated) {
    const redirectUrl = getLoginRedirectUrl();
    window.location.href = redirectUrl;
  }
}
